import SidebarAudiences from './SidebarAudiences'

export default SidebarAudiences
